import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NbDateService } from '@nebular/theme';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AddPhoto } from 'src/app/shared/constants/add-photo';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { COUNTRIES_DE, COUNTRIES_EN, COUNTRIES_ES, COUNTRIES_FR } from 'src/assets/common/countries';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  maxBirthdate: any;
  birthdate: any;
  loadingSpinner = false;
  isSubmitted = false;
  isUsernameUsed = false;
  isEmailUsed = false;
  imageChangedEvent: any = '';
  croppedImage: any;
  croppedImageFile: any;
  tempCroppedImage: any;
  displayedPhoto: any;
  createUserForm: UntypedFormGroup;
  year: any;
  langueStorage: any;
  countries: any;
  showButtonEditPhoto = false;
  user: any;
  dateBirth: any;
  storedLanguage: string;
  isEmailValid = false;
  selectedCountry: any;
  addPhoto = new AddPhoto();
  mode;
  genders;
  typesUser;
  languages;
  constructor(
    private readonly constantService: ConstantService,
    private readonly translate: TranslateService,
    private readonly enterpriseService: EnterpriseService,
    private readonly dateService: NbDateService<Date>,
    private readonly authService: AuthService,
    private readonly ref: ChangeDetectorRef,
    private readonly storageService: CustomStorageService) {
    this.maxBirthdate = this.dateService.today();
  }

  ngOnInit() {
    this.mode = this.storageService.getEnterprise().mode;
    this.genders = [
      { name: this.translate.instant('Male'), code: 'Male' },
      { name: this.translate.instant('Female'), code: 'Female' },
    ];

    this.typesUser = [
      { name: this.translate.instant('EnterpriseOfficer'), code: 'EnterpriseOfficer' },
      { name: this.translate.instant('Member'), code:  this.mode ==='B2B' ? 'EnterpriseMember' : 'Member'},
    ];

    this.languages = [
      { name: this.translate.instant('allemand'), code: 'al' },
      { name: this.translate.instant('english'), code: 'en' },
      { name: this.translate.instant('espagnol'), code: 'es' },
      { name: this.translate.instant('french'), code: 'fr' },
    ];

    this.translateCountryOptions();
    this.initializeUser();
    this.initializeForm();
  }

  translateCountryOptions() {
    this.storedLanguage = localStorage.getItem('storage-language');
    switch (this.storedLanguage) {
      case 'en':
        this.countries = COUNTRIES_EN;
        this.selectedCountry = 'France';
        this.sortedCountries();
        break;
      case 'de':
        this.countries = COUNTRIES_DE;
        this.selectedCountry = 'France';
        this.sortedCountries();
        break;
      case 'es':
        this.countries = COUNTRIES_ES;
        this.selectedCountry = 'France';
        this.sortedCountries();
        break;
      default:
        this.countries = COUNTRIES_FR;
        this.selectedCountry = 'France';
        this.sortedCountries();
        break;
    }
  }

  sortedCountries() {
    this.countries = this.countries.sort((n1, n2) => {
      if (n1.name > n2.name) {
        return 1;
      }
      if (n1.name < n2.name) {
        return -1;
      }
      return 0;
    });
  }

  initializeForm() {
    this.createUserForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]), // this.email,
      username: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]), // this.username,
      firstName: new UntypedFormControl(),
      lastName: new UntypedFormControl(),
      gender: new UntypedFormControl('Male'),
      type: new UntypedFormControl('', [Validators.required]),
      birthdate: new UntypedFormControl(),
      locale: new UntypedFormControl('fr'),
      address: new UntypedFormControl(),
      city: new UntypedFormControl(),
      zipCode: new UntypedFormControl(),
      phoneNumber: new UntypedFormControl(),
      country: new UntypedFormControl(this.selectedCountry),
      photo: new UntypedFormControl(),
    });
    this.displayedPhoto = (this.displayedPhoto ? '../../../../assets/images/user.svg' : '../../../../../assets/images/user.svg');
    this.createUserForm.controls.gender.setValue(this.genders.find(gender => gender.code === 'Male' ));
    this.createUserForm.controls.type.setValue(this.typesUser.find(type => type.code === 'EnterpriseOfficer' ));
    this.createUserForm.controls.country.setValue(this.countries.find(country => country.code === 'fr' ));
    this.createUserForm.controls.locale.setValue(this.languages.find(language => language.code === 'fr' ));
  }

  get email() {
    return this.createUserForm.get('email');
  }

  get username() {
    return this.createUserForm.get('username');
  }

  /**
   * function is called to control valid form to create employees.
   */
  onCreateClick() {
    this.loadingSpinner = true;
    this.isSubmitted = true;
    if (this.createUserForm.valid) {
      this.createEmployee();
      this.createUserForm.disable();
    } else {
      this.loadingSpinner = false;
    }
  }

  /**
   * function is called to get user from locolstorage
   */
  initializeUser() {
    const today = new Date();
    this.user = this.storageService.getUser();
    this.dateBirth = today.setFullYear(today.getFullYear() - 40);
  }

  /**
   * function is called to create employees.
   */
  createEmployee() {
    const formData = new FormData();
    for (const key of Object.keys(this.createUserForm.controls)) {
      if (this.createUserForm.get(key).value) {
        if (key !== 'photo') {
          if(key === 'type' || key === 'locale' || key === 'country' || key === 'gender')
            {formData.append(key, this.createUserForm.controls[key].value.code);}
          else
            {formData.append(key, this.createUserForm.controls[key].value);}
        }
      }
    }
    if (this.croppedImageFile) {
      formData.append('photo', this.croppedImageFile);
    }
    formData.append('enterprise', this.storageService.getEnterprise().id);
    const enterprise = this.storageService.getEnterprise();
    this.enterpriseService
      .createEmployee(enterprise.id, formData)
      .subscribe(data => {
        this.loadingSpinner = false;
        this.constantService.showSuccessToast('toast.user_add_success');
        this.constantService.navigateToUsers('/list');
      }, error => {
        this.loadingSpinner = false;
        switch (error.status) {
          case 400:
            if (error.error.message[0] === 'email must be an email') {
              this.isEmailValid = true;
              this.scrollToTop();
            }
            break;
          case 401:
            this.authService.logout();
            break;
          case 409:
            switch (error.error.cause) {
              case 'EMAIL':
                this.isEmailUsed = true;
                this.scrollToTop();
                break;
              case 'USERNAME':
                this.isUsernameUsed = true;
                this.scrollToTop();
                break;
            }
            break;
          default:
            this.constantService.showErrorToast('toast.user_add_fail');
            break;
        }
        this.loadingSpinner = false;
      });
    this.isEmailUsed = false;
    this.isUsernameUsed = false;
  }

  onEmailChange(event) {
    if (this.createUserForm.controls.email.valid) {
      const text = event.target.value;
      const lastString = text.substring(text.toString().lastIndexOf('.') + 1, text.length);
      const verify = !/[^a-z]/i.test(lastString);
      verify ? this.isEmailValid = false : this.isEmailValid = true;
    } else {
      this.isEmailValid = false;
    }
  }

  onCredentialsChange() {
    this.isEmailUsed = false;
    this.isUsernameUsed = false;
    this.isEmailValid = false;
    if (this.email.valid && this.username.valid) {
      const credentials = {
        email: this.email.value,
        username: this.username.value
      };
      this.authService.verifyCredentials(credentials).subscribe(
        (res: any) => {
          this.scrollToTop();
          this.isEmailUsed = res?.isEmailUsed;
          this.isUsernameUsed = res?.isUsernameUsed;
          this.ref.detectChanges();
        },
        error => {
          if (error.error.statusCode === 409) {
            this.scrollToTop();
            this.isEmailUsed = error.error.isEmailUsed;
            this.isUsernameUsed = error.error.isUsernameUsed;
            this.ref.detectChanges();
          }
        }
      );
    }
  }

  scrollToTop() {
    const element = document.getElementById('addPhotoElement').scrollIntoView({ behavior: 'smooth' });
  }

  /**
   * function is called to confirm image cropped
   */
  confirmImage() {
    if (this.tempCroppedImage) {
      this.displayedPhoto = this.tempCroppedImage;
    }
  }

  /**
   * function is called to crop image user
   */
  imageCropped(event: ImageCroppedEvent) {
    this.tempCroppedImage = event.base64;
    this.croppedImage = event.base64;
    this.croppedImageFile = this.addPhoto.dataURItoBlob(this.croppedImage);
    this.showButtonEditPhoto = true;

  }

  /**
   * function is called to valid crop image.
   */
  validImage() {
    this.displayedPhoto = this.croppedImage;
  }

  /**
   * function is called to change file image.
   */
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }


}
